var render = function (_h,_vm) {var _c=_vm._c;return _c('kw-button',_vm._g({staticClass:"button-closer",attrs:{"button-type":"text","data-cy":"button-closer","prepend-icon-class":"kw kw-x"}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }